// extracted by mini-css-extract-plugin
export default {"cardWrapper":"ElectricCard_cardWrapper__Nab+d","card":"ElectricCard_card__EW6oG","unit":"ElectricCard_unit__4+gan","num":"ElectricCard_num__zN6O3"};